/**
 * @file Award Banner
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Award Banner component
 */
const vAwardBanner = () => {
	const awardBanner = document.querySelector( '.v-award-banner' );

	if ( ! awardBanner ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	const inner       = awardBanner.querySelector( '.v-award-banner__inner' );
	const tweenVars   = {
		opacity:  1,
		duration: 1,
		ease:     'power1.inOut',
	};
	const triggerVars = {
		trigger:       awardBanner,
		toggleActions: 'play none none reset',
	};

	gsap.fromTo( inner, { opacity: 0 }, {
		scrollTrigger: {
			start: 'top bottom-=10%',
			...triggerVars,
		},
		...tweenVars,
	} );
};

export default vAwardBanner;
